'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.OrganisationseinheitSchema = {
  title: 'Organisationseinheit',
  type: 'object',
  properties: Object.assign({}, baseProperties, {
    beginn: {
      type: 'string',
      format: 'date-time'
    },
    ende: {
      type: 'string',
      format: 'date-time'
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/organisationseinheit.js
// module id = 5tJL
// module chunks = 0